import { render } from "./TheL04Pagination.vue?vue&type=template&id=79bf85a9&scoped=true&ts=true"
import script from "./TheL04Pagination.vue?vue&type=script&lang=ts"
export * from "./TheL04Pagination.vue?vue&type=script&lang=ts"

import "./TheL04Pagination.vue?vue&type=style&index=0&id=79bf85a9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bf85a9"]])

export default __exports__